import { useCallback } from "react"
import {
  Block,
  Button,
  CoinsSwap02,
  Mats,
  ParagraphSmall,
  useStyletron,
} from "@mezo-org/mezo-clay"

import {
  selectMats,
  selectWalletBalances,
  setOpenModal,
  useDappDispatch,
  useDappSelector,
} from "#/redux-state"
import { IS_MEZO_MAINNET } from "#/shared/constants"
import {
  bigIntToCommaSeparatedFloat,
  separateThousandsWithComaRegExp,
} from "#/shared/utils"

import HomepageMainSectionAssetsItem from "./HomepageMainSectionAssetsItem"

export default function HomepageMainSectionAssetsMats() {
  const { totalMats } = useDappSelector(selectMats)
  const { mBTC } = useDappSelector(selectWalletBalances)

  const [css] = useStyletron()

  const dispatch = useDappDispatch()

  const convertButtonHandler = useCallback(() => {
    if (IS_MEZO_MAINNET) return

    dispatch(setOpenModal("stack-matsnet-btc"))
  }, [dispatch])

  return (
    <HomepageMainSectionAssetsItem
      header={<Mats size={16} />}
      value={
        <>
          <Block
            as="span"
            className={css({ color: totalMats > 0 ? "black" : "#A6A6A6" })}
          >
            {separateThousandsWithComaRegExp(totalMats.toString())}
          </Block>{" "}
          mats
        </>
      }
      label={
        <>
          <ParagraphSmall
            color={mBTC.balance > 0n ? "contentPrimary" : "contentSecondary"}
            display="inline-block"
          >
            {bigIntToCommaSeparatedFloat(mBTC.balance, 10, 10, 0)}
          </ParagraphSmall>{" "}
          <ParagraphSmall color="contentPrimary" display="inline-block">
            sats
          </ParagraphSmall>
        </>
      }
      buttons={[
        <Button
          data-attr="convert_mats_cta"
          onClick={convertButtonHandler}
          size="small"
          startEnhancer={<CoinsSwap02 color="white" size={16} />}
        >
          Convert
        </Button>,
      ]}
    />
  )
}
